module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_flatpack_desktop-9fc03ec7c2fb4207903e7b403d5d5d4b.png";